import React, { Suspense, useCallback, useEffect, useMemo, useState, useRef } from 'react';
import { Modal, Spin } from "antd";
import { Modal as BootstrapModal } from 'react-bootstrap';
import moment from 'moment';
import { Link } from "react-router-dom";
import signal2 from '../../../assets/img/secondsignal.png';
import signal3 from '../../../assets/img/signal3.png';
import signal4 from '../../../assets/img/signal4.png';
import signal5 from '../../../assets/img/signal5.png';
import { BootstrapTooltip } from '../../../Commoncomponet/common';

const throttle = (func, limit) => {
    let lastFunc;
    let lastRan;
    return function (...args) {
        if (!lastRan) {
            func.apply(this, args);
            lastRan = Date.now();
        } else {
            clearTimeout(lastFunc);
            lastFunc = setTimeout(() => {
                if ((Date.now() - lastRan) >= limit) {
                    func.apply(this, args);
                    lastRan = Date.now();
                }
            }, limit - (Date.now() - lastRan));
        }
    };
};

export default function MeterVirtualizationModal({
    isModalVisible,
    handleCancel,
    ModelId,
    tableData,
    ModalLoad,
    tabShow,
    Download_Logs,
    AllCategory,
    MeterDetails,
    onHandaleViewGSM,
    getSecondsTodayBydate,
    seconTominutesConveter,
    exports,
    ColorText,
    ModemData
}) {
    const [visibleRows, setVisibleRows] = useState(50);
    const [sortedData, setSortedData] = useState(tableData || []);
    const modalBodyRef = useRef(null);

    useEffect(() => {
        setVisibleRows(Math.min(50, tableData.length));
        setSortedData(tableData);
    }, [isModalVisible, tableData]);

    useEffect(() => {
        if (!isModalVisible || !modalBodyRef.current) return;

        const handleScroll = throttle(() => {
            const element = modalBodyRef.current;
            const { scrollTop, scrollHeight, clientHeight } = element;

            const triggerPoint = scrollHeight * 0.85;

            if (scrollTop + clientHeight >= triggerPoint) {
                setVisibleRows(prev => {
                    const next = prev + 50;
                    return next >= tableData.length ? tableData.length : next;
                });
            }
        }, 200);

        const scrollElement = modalBodyRef.current;
        scrollElement.addEventListener('scroll', handleScroll);

        return () => {
            scrollElement.removeEventListener('scroll', handleScroll);
        };
    }, [isModalVisible, tableData.length]);

    return (
        <Suspense fallback={<Spin size="large" />}>
            <Modal title={<div className="d-flex"><h5 style={{ color: ColorText }}>{ModelId}</h5>{sortedData.length > 0 ? <span className='btn btn-primary text-white ml-2' onClick={Download_Logs}><i className='fas fa-download'></i></span> : ''}{sortedData.length > 0 ? <Link to={{ pathname: `All-GSM`, state: { detail: sortedData.map((data) => (data?.UNIQUE_ID)), title: ModelId } }}><span className='btn btn-primary text-white ml-2'><i className='fas fa-up-right-from-square'></i></span></Link> : ''}</div>} maskClosable={false} className="my-modal-class" visible={isModalVisible} footer='' onCancel={handleCancel} width={1000} style={{ overlay: { zIndex: 1000 } }} closable={!ModalLoad}>
                <div>
                    <div className="modal-table">
                        {ModalLoad ? (
                            <div className="example">
                                <Spin size="large" />
                            </div>
                        ) : <table className="table border table-borderless" id="table-1">
                            <thead style={{ position: 'sticky', top: '0', background: '#fff' }}>
                                <tr>
                                    <th className="text-center">SR NO.</th>
                                    <th >Consumer Name</th>
                                    <th className="text-center">Category</th>
                                    <th>Modem Serial No</th>
                                    <th className="text-center">EVC Type</th>
                                    <th className="text-center">Installation Number</th>
                                    {ModelId?.split('(')[0] == 'Consumption' || ModelId?.split('(')[0] == '0 Consumption' || ModelId?.split('(')[0] == 'Null Data Count' ? <th>Consumption</th> : ''}
                                    {ModelId?.split('(')[0] == 'QMIN UNDER' || ModelId?.split('(')[0] == 'QMIN OK' || ModelId?.split('(')[0] == 'Null Data IN QMIN Count' ? <><th>QMIN</th><th>QMIN Limit</th></> : ''}
                                    {ModelId?.split('(')[0] == 'QMAX OVER' || ModelId?.split('(')[0] == 'QMAX OVER' || ModelId?.split('(')[0] == '0 QMAX' || ModelId?.split('(')[0] == 'Null Data IN QMAX Count' ? <><th>QMAX</th><th>QMAX Limit</th></> : ''}
                                    {ModelId?.split('(')[0] == 'QAVG' || ModelId?.split('(')[0] == '0 QAVG' || ModelId?.split('(')[0] == 'Null Data IN QAVG Count' ? <th>QAVG</th> : ''}
                                </tr>
                            </thead>
                            <tbody id="tbody">
                                <>
                                    {sortedData.length > 0 ?
                                        sortedData.slice(0, visibleRows).map((data, id) => (
                                            <tr style={{ height: "4rem", cursor: 'pointer' }} className="trheigth even:tw-bg-gray-100 hover:tw-bg-[#D8D8D8]" key={id} onMouseEnter={() => {
                                                var element = document.getElementById(data?.UNIQUE_ID + 'GSM');
                                                element.classList.add('within');
                                                element.classList.remove('display-icon');
                                            }} onMouseLeave={() => {
                                                var element = document.getElementById(data?.UNIQUE_ID + 'GSM');
                                                element.classList.add('display-icon');
                                                element.classList.remove('within');
                                            }}>
                                                <td className="GSM_Link">
                                                    <a className="!tw-text-[#1890ff]" onClick={() => onHandaleViewGSM(data?.UNIQUE_ID)}>{id + 1}</a>
                                                    <a id={data?.UNIQUE_ID + 'GSM'} className='display-icon !tw-text-[#1890ff]' onClick={() => onHandaleViewGSM(data?.UNIQUE_ID)}><img src={exports} style={{ height: "10px" }} /></a></td>
                                                <td>{data?.address_compony_name}</td>
                                                <td className='tw-min-w-[150px] text-center' >
														{AllCategory?.category5.filter((inac) => (inac?.UNIQUE_ID === data?.CAT5_ID))[0]?.NAME || AllCategory?.category4.filter((inac) => (inac?.CATEGORY4_UNIQUE_ID === data?.CAT4_ID))[0]?.CATEGORY4_NAME || AllCategory?.category3.filter((inac) => (inac?.CATEGORY3_UNIQUE_ID === data?.CAT3_ID))[0]?.CATEGORY3_NAME || AllCategory?.category2.filter((inac) => (inac?.CATEGORY2_UNIQUE_ID === data?.CAT2_ID))[0]?.CATEGORY2_NAME || AllCategory?.category1.filter((inac) => (inac?.CATEGORY1_UNIQUE_ID === data?.CAT1_ID))[0]?.CATEGORY1_NAME || AllCategory?.category0.filter((inac) => (inac?.UNIQUE_ID === data?.CAT0_ID))[0]?.CATEGORY0}
												</td>
                                                <td>{data?.DEVICE_SERIAL_NO}</td>

                                                <td>{ModemData.filter((met) => (met?.METER_UNIQUE_ID == (data?.SCRIPTDECODE_ID?.split('_')[1])))[0]?.METER_PROFILE_NAME}</td>
                                                <td>{data?.INSTALLATION_NUMBER}</td>
                                                {ModelId?.split('(')[0] == 'Consumption' || ModelId?.split('(')[0] == '0 Consumption' || ModelId?.split('(')[0] == 'Null Data Count' ? <td>{data?.CONSUMPTION}</td> : ''}
                                                {ModelId?.split('(')[0] == 'QMIN UNDER' || ModelId?.split('(')[0] == 'QMIN OK' || ModelId?.split('(')[0] == '0 QMIN' || ModelId?.split('(')[0] == 'Null Data IN QMIN Count' ? <> <td>{data?.CONSUMPTION}</td><td>{data?.MECHANICAL_MIN_RATE_QMIN}</td> </> : ''}
                                                {ModelId?.split('(')[0] == 'QMAX OVER' || ModelId?.split('(')[0] == 'QMAX OVER' || ModelId?.split('(')[0] == '0 QMAX' || ModelId?.split('(')[0] == 'Null Data IN QMAX Count' ? <><td>{data?.CONSUMPTION}</td><td>{data?.MECHANICAL_MAX_RATE_QMAX}</td></> : ''}
                                                {ModelId?.split('(')[0] == 'QAVG' || ModelId?.split('(')[0] == '0 QAVG' || ModelId?.split('(')[0] == 'Null Data IN QAVG Count' ? <td>{data?.CONSUMPTION}</td> : ''}
                                            </tr>
                                        )) : <tr></tr>}
                                </>
                            </tbody>
                        </table>}
                        {sortedData.length == 0 && !ModalLoad && <h4 className="text-center">No Data Found</h4>}

                    </div>
                </div>
            </Modal>
        </Suspense>
    );
}